/* Libs */
import React, { useCallback, useEffect, useRef, useState } from 'react';
/* Components */
import ReactPlayer from 'react-player/lazy';
import AudioVisualizer from 'components/AudioVisualizer';

import { Modal } from './styles';

interface IProps {
  open: boolean;
  pipe: boolean;
  url: string;
  type?: 'audio' | 'video';
  toggleModal(): void;
  enableDownload?: string;
  startAt?: number; // Tempo de início do vídeo em segundos
}

const PlayerBaixa: React.FC<IProps> = ({
  open,
  pipe,
  url,
  toggleModal,
  type = 'video',
  enableDownload = '',
  startAt = 0,
}: IProps) => {
  const playerRef = useRef<ReactPlayer | null>(null);
  const [seek, setSeek] = useState(false);

  function closeModal() {
    toggleModal();
  }
  const onReady = useCallback(() => {
    if (!seek && startAt && playerRef.current) {
      playerRef.current.seekTo(startAt, 'seconds'); // Faz o vídeo iniciar no startAt
      setSeek(true);
    }
  }, [seek, startAt]);

  useEffect(() => {
    setSeek(false); // Quando a url é alterada, verificar se precisa fazer seek
  }, [url]);

  return open && pipe === false ? (
    <Modal
      open={open}
      onClose={() => closeModal()}
      animationDuration={0}
      styles={{
        modal: {
          borderRadius: '20px',
          background: '#333',
          maxWidth: 'unset',
          height: '59.6vmin',
          padding: '0',
        },
        overlay: {
          background: 'rgba(0, 0, 0, 0.3)',
        },
        closeButton: {
          background: 'rgba(0, 0, 0, 0.5)',
          fill: 'rgba(255, 255, 255, 0.8)',
          borderRadius: '50%',
        },
      }}
      center
    >
      {type === 'video' ? (
        <ReactPlayer
          ref={playerRef}
          controls
          playing
          onReady={onReady}
          url={url}
          width="auto"
          height="100%"
          config={{
            file: {
              attributes: {
                onContextMenu: (e: any) => e.preventDefault(),
                controlsList: enableDownload,
                disablePictureInPicture: true,
              },
            },
          }}
        />
      ) : (
        <AudioVisualizer url={url} />
      )}
    </Modal>
  ) : null;
};

export default PlayerBaixa;
